import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import './Profile.css';

function Profile() {
  const [user, setUser] = useState(null);
  const [editing, setEditing] = useState(false);
  const [profile, setProfile] = useState({ displayName: '', email: '', phone: '', bio: '' });

  useEffect(() => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      setUser(currentUser);
      setProfile({
        displayName: currentUser.displayName || '',
        email: currentUser.email || '',
        phone: '',
        bio: ''
      });
    }
  }, []);

  const handleSave = () => {
    setEditing(false);
    alert('Profile updated!');
  };

  if (!user) return <div className="loading">Loading...</div>;

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-avatar">{user.displayName?.charAt(0) || 'U'}</div>
        <div className="profile-info">
          <h1>{profile.displayName || user.email}</h1>
          <p>Member since 2026</p>
        </div>
      </div>

      <div className="profile-card">
        <div className="card-header">
          <h2>Profile Information</h2>
          <button 
            onClick={() => setEditing(!editing)}
            className="edit-btn"
          >
            {editing ? 'Cancel' : 'Edit'}
          </button>
        </div>

        <div className="profile-form">
          <div className="form-group">
            <label>Full Name</label>
            {editing ? (
              <input
                type="text"
                value={profile.displayName}
                onChange={(e) => setProfile({...profile, displayName: e.target.value})}
              />
            ) : (
              <p>{profile.displayName || 'Not set'}</p>
            )}
          </div>

          <div className="form-group">
            <label>Email</label>
            <p>{profile.email}</p>
          </div>

          <div className="form-group">
            <label>Phone</label>
            {editing ? (
              <input
                type="tel"
                value={profile.phone}
                onChange={(e) => setProfile({...profile, phone: e.target.value})}
                placeholder="Your phone number"
              />
            ) : (
              <p>{profile.phone || 'Not set'}</p>
            )}
          </div>

          <div className="form-group">
            <label>Bio</label>
            {editing ? (
              <textarea
                value={profile.bio}
                onChange={(e) => setProfile({...profile, bio: e.target.value})}
                placeholder="Tell hosts about yourself"
              />
            ) : (
              <p>{profile.bio || 'Not set'}</p>
            )}
          </div>

          {editing && (
            <button onClick={handleSave} className="save-btn">Save Changes</button>
          )}
        </div>
      </div>

      <div className="profile-card">
        <h2>Verification</h2>
        <div className="verification-item">
          <span>Email verified</span>
          <span className="verified">✓</span>
        </div>
        <div className="verification-item">
          <span>Phone verified</span>
          <span className="unverified">✗</span>
        </div>
      </div>
    </div>
  );
}

export default Profile;
